<template>
  <form @submit.prevent="validateBeforeSubmit">
    <div class="modal-card" style="width: 640px">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <b-field label="ID" v-if="id">
          <b-input placeholder="ID" disabled v-model="model.id"></b-input>
        </b-field>
        <b-field
          label="Наименование">
          <b-input
            name="name"
            placeholder="Наименование"
            icon="user"
            v-model="model.name">
          </b-input>
        </b-field>
        <b-field
          label="Описание">
          <b-input
            name="title"
            placeholder="Описание"
            icon="user"
            v-model="model.title">
          </b-input>
        </b-field>
        <b-field
          label="Другое описание">
          <b-input
            name="another_title"
            placeholder="Другое описание"
            icon="user"
            v-model="model.another_title">
          </b-input>
        </b-field>
        <b-field
          label="Цвет">
          <swatches v-model="model.color" show-fallback>
            <b-input name="color" slot="trigger" :value="model.color"></b-input>
          </swatches>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary">Сохранить</button>        
        <button class="button" type="button" @click="$parent.close()">Закрыть</button>
      </footer>
    </div>
  </form>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
    events: '',
});

// import Swatches from 'vue-swatches'
import "vue-swatches/dist/vue-swatches.min.css"

import { EventBus } from '@/utils'

export default {
  name: 'GroupForm',
  components: {
    Swatches: () => import('vue-swatches'),
  },
  props: {
    id: Number,
    title: String
  },
  data: function () {
    return {
      confirmPassword: '',
      model: {
        id: undefined,
        name: '',
        title: '',
        another_title: '',
        color: undefined
      },
      purge_model: {
        id: undefined,
        name: '',
        title: '',
        another_title: '',
        color: undefined
      },
    }
  },
  created: function() {
    //
  },
  computed: {
    //
  },
  beforeMount: function(){
    //
  },
  mounted () {
    let $this = this

    if ($this.id){
      this.$store.dispatch('getGroup', $this.id)
        .then(response => {
          let data = response.data.data;
          $this.model = data
        })
        .catch(error => {
          this.model = this.purge_model
        })
    }
  },
  methods: {
    validateBeforeSubmit() {
      let $this = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          $this.doUpdate()
          return;
        }
        this.$toast.open({
          message: $this.$i18n.t('notify.form_error'),
          type: 'is-danger',
          position: 'is-bottom'
        })
      });
    },
    doUpdate () {
      let $this = this
      if ($this.id){
        $this.$store.dispatch('updateGroup', $this.model)
      }
      else{
        $this.$store.dispatch('createGroup', $this.model)
      }
    }
    
  }
}
</script>

<style scoped>
</style>
<style>
</style>